import { render, staticRenderFns } from "./receipt-card-carousel.vue?vue&type=template&id=09d5fd5a"
import script from "./receipt-card-carousel.vue?vue&type=script&lang=js"
export * from "./receipt-card-carousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports